import type { HotStreakState, MascotId } from '@flip7/shared';
import { HS_MASCOTS } from '@flip7/shared';

interface Props {
  state: HotStreakState;
  playerId: string | null;
}

const POSITION_LABELS = ['1st', '2nd', '3rd', '4th'];

const MASCOT_EMOJI: Record<MascotId, string> = {
  hurley: '🌭',
  gobbler: '🐻',
  dangle: '🐟',
  mum: '👑',
};

export function HotStreakResults({ state, playerId }: Props) {
  const sorted = [...state.finishOrder].sort((a, b) => a.position - b.position);

  return (
    <div className="hs-results">
      <h2>Race {state.currentRace} Results</h2>

      {/* Podium */}
      <div className="hs-podium">
        {sorted.map((finish) => {
          const info = HS_MASCOTS[finish.mascot];
          return (
            <div key={finish.mascot} className={`hs-podium-entry hs-pos-${finish.position}`}>
              <div className="hs-podium-rank">{POSITION_LABELS[finish.position - 1]}</div>
              <div className="hs-podium-mascot">
                <span className="hs-podium-emoji">{MASCOT_EMOJI[finish.mascot]}</span>
                <span style={{ color: info.color }}>{info.name}</span>
              </div>
              {finish.finishType === 'dq' && <span className="hs-dq-badge">DQ</span>}
            </div>
          );
        })}
      </div>

      {/* Player payouts */}
      <div className="hs-payouts">
        <h3>Payouts</h3>
        {state.players.map((player) => {
          const payout = state.racePayouts[player.id] ?? 0;
          const isYou = player.id === playerId;
          return (
            <div key={player.id} className={`hs-payout-row ${isYou ? 'hs-payout-you' : ''}`}>
              <span className="hs-payout-name">
                {player.name}{isYou ? ' (You)' : ''}
              </span>
              <span className={`hs-payout-amount ${payout >= 0 ? 'positive' : 'negative'}`}>
                {payout >= 0 ? '+' : ''}{payout}
              </span>
              <span className="hs-payout-total">${player.money}</span>
            </div>
          );
        })}
      </div>

      {state.currentRace < 3 && (
        <p className="hs-next-race-hint">Next race starting soon...</p>
      )}
    </div>
  );
}
